import type { UseActionResult } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { Logistic, SetLogisticShippingRateArgs } from '@ztechapps/common.contract'
import { setLogisticShippingRateQuery } from './graphql'

export type UseSetLogisticShippingRateResult = UseActionResult<Logistic, SetLogisticShippingRateArgs>

export const useSetLogisticShippingRate = (): UseSetLogisticShippingRateResult =>
  useActionMutation<Logistic, SetLogisticShippingRateArgs>({ query: setLogisticShippingRateQuery })
